import React from "react";
import { evaluateTone, toneHex } from "../utils/statusSemantics";

const isNil = (value) => value === null || value === undefined;

const formatPercentText = (value, digits = 1) => {
    if (isNil(value) || Number.isNaN(Number(value))) return "--";
    return `${(Number(value) * 100).toFixed(digits)}%`;
};

/**
 * 通用状态圆点。tone 直接给，或传 value+thresholds 自动评估。
 */
export function StatusDot({ tone, value, thresholds, size = 8, style }) {
    const resolved = tone || evaluateTone(value, thresholds);
    return (
        <span
            aria-hidden="true"
            style={{
                display: "inline-block",
                width: size,
                height: size,
                borderRadius: "50%",
                background: toneHex(resolved),
                flex: "0 0 auto",
                ...style,
            }}
        />
    );
}

/**
 * 阈值进度条：一个比率值按红黄绿阈值着色，配标签和数值。
 * 用于运力锁定率、完成率、利用率等「比率 + 阈值」场景。
 */
export function ThresholdBar({ label, value, thresholds, valueText, subText, target }) {
    const tone = evaluateTone(value, thresholds);
    const hex = toneHex(tone);
    const pct = isNil(value) || Number.isNaN(Number(value)) ? 0 : Math.max(0, Math.min(100, Number(value) * 100));
    const targetPct = isNil(target) ? null : Math.max(0, Math.min(100, Number(target) * 100));

    return (
        <div className="business-dashboard-threshold">
            <div className="business-dashboard-threshold-head">
                <span className="business-dashboard-threshold-label">{label}</span>
                <span className="business-dashboard-threshold-value" style={{ color: hex }}>
                    {valueText ?? formatPercentText(value)}
                </span>
            </div>
            <div className="business-dashboard-threshold-track">
                <span className="business-dashboard-threshold-fill" style={{ width: `${pct}%`, background: hex }} />
                {targetPct !== null ? (
                    <span className="business-dashboard-threshold-target" style={{ left: `${targetPct}%` }} title={`目标 ${formatPercentText(target)}`} />
                ) : null}
            </div>
            {subText ? <div className="business-dashboard-threshold-sub">{subText}</div> : null}
        </div>
    );
}
